import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('PureMultipleChoiceExercise', LATEST_SCHEMA_VERSION.PureMultipleChoiceExercise);
export default exerciseTypeVersionAdapter;